<template>
    <div id="full-container">
        <h1 id="top-text-2">
            <input type="text" v-model="localPlanTypeString" class="input-as-text" :style="{ width: (localPlanTypeString.length) + 'ch' }"/>Plans
        </h1>
        <div id="window-2">
            <div id="top-row">
                <h2 class="top-description">Adjust the included plan benefit values to determine appropriate pricing.</h2>
            </div>
            <div class="slider-rows">
                <SliderRow v-for="(row, index) in benefitRows" :index="index" :benefit="row.benefit" :key="row.key" :planType="planType" :inputPercent="percentToSetTo" @benefitPriceUpdated="updatePlanPrices" @edit-benefit="ShowEditBenefit"/>
            </div>
            <div class="btn-container">
                <button class="add-btn hover-grow" @click="addBenefitClick">+ Add Benefit</button>
                <button class="add-btn hover-grow" @click="ShowEditPlan">Edit Plan Details</button>
            </div>
            <div class="bottom-row">
                <!-- <div class="fees-tab">
                    <div class="breakage"> -->
                            
                        <!-- <div class="left-row" style="margin-bottom: 0em;">
                            <span class="breakage-text">Breakage Assumption:</span>
                            <div class="breakage-2">
                                <div class="plus-minus-buttons">
                                    <PlusMinusButton class="plus-minus" :char="'+'" @plusMinusClick="UpdatePercentBreakage"/>
                                    <PlusMinusButton class="plus-minus" :char="'-'" @plusMinusClick="UpdatePercentBreakage"/>
                                </div>
                                <div class="breakage-box no-select">{{ percentBreakage }}<span style="font-size: 0.65em;">%</span></div>
                            </div>
                        </div>
                        <div class="left-row">
                            <span class="breakage-text">Include Dental Menu Fee:</span>
                            <div class="checkbox-container grow-medium">
                                <div class="checkbox" @click="toggleDMFeeChecked($event)">
                                    <div class="checkbox-fill" v-if="includeDMFee">
                                        <p class="checkbox-text">✓</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="left-row">
                            <span class="breakage-text">Include Processing Fee:</span>
                            <div class="checkbox-container grow-medium">
                                <div class="checkbox" @click="toggleProcessingFeeChecked($event)">
                                    <div class="checkbox-fill" v-if="includeProcessingFee">
                                        <p class="checkbox-text">✓</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="plans-tab">
                    <div class="plan-description">
                        <h3>Choose how often patients can come in</h3>
                    </div>
                    <div class="plans">
                        <Plan v-for="plan in plans" :key="plan.id" :plan="plan" :mode="mode" @UpdatePriceFromPlan="updatePlanPrices"/>
                    </div>
                  </div>
            </div>
        </div>
        <SaveChangesButton v-if="this.mode === 'view'" @btnPressed="GoToOverview()"></SaveChangesButton>
        
        <!-- Consolidated modal overlay -->
        <transition name="fade" mode="out-in">
            <div class="modal-overlay" v-if="showEditBenefit || showModal || showEditPlan" @click.self="closeAllModals">
                <EditBenefitDetailsModal v-if="showEditBenefit" @click.stop @exitModal="closeAllModals" :propBenefit="benefitToEdit" :planType="planType" @recalculatePrices="updatePlanPrices" />
                
                <AddBenefitModal v-if="showModal" @click.stop @exitModal="closeAllModals" :planType="planType" />
                
                <EditPlanDetailsModal 
                    v-if="showEditPlan" 
                    @click.stop 
                    @exitModal="closeAllModals"
                    :planType="planType"
                    :planTypeString="localPlanTypeString"
                    :percentBreakage="percentBreakage"
                    :includeDMFee="includeDMFee"
                    :includeProcessingFee="includeProcessingFee"
                    :percentToSetTo="percentToSetTo"
                    :percentDiscount="percentDiscount"
                    @updatePercentBreakage="UpdatePercentBreakage"
                    @toggleDMFee="toggleDMFeeChecked"
                    @toggleProcessingFee="toggleProcessingFeeChecked"
                    @updatePercentToSetTo="updatePercentToSetTo"
                />
            </div>
        </transition>
        
    </div>
</template>

<script>
import SliderRow from './SliderRow.vue'
import Plan from './Plan.vue'
// import PlusMinusButton from './PlusMinusButton.vue';
import AddBenefitModal from './modals/AddBenefitModal.vue';
import EditBenefitDetailsModal from './modals/EditBenefitDetailsModal.vue'
import EditPlanDetailsModal from './modals/EditPlanDetailsModal.vue'
import SaveChangesButton from './SaveChangesButton.vue';
import { GoToComponent, CalculateComputedPlanPrice, canBenefitHaveMultipleQuantity } from '../utils/functions';
import { mapActions } from 'vuex';
export default {
    components: {
        SliderRow,
        Plan,
        // PlusMinusButton,
        AddBenefitModal,
        SaveChangesButton,
        EditBenefitDetailsModal,
        EditPlanDetailsModal,
    },
    props: {
        planType: Number,
        mode: String,
    },
    data() {
        return {
            showModal: false,
            showEditBenefit: false,
            showEditPlan: false,
            benefitToEdit: null,
            localPlanType: "",
            computedPlanStringLength: 0,
            localPlanTypeString: "",
            percentToSetTo: 0,
        }
    },
    methods: {
        ...mapActions(['updatePlan',
        "updatePercentBreakageStore",
        "toggleIncludeDMFee",
        "toggleIncludeProcessingFee",
        "setPlanTypeName",
        "getPlanTypeFromInt",
        "updateAdultPlanDiscount"]),
        updatePlanPrices() {
            this.plans.forEach((plan) => {
                if(plan.monthlyPriceAltered) {
                    return;
                }
                plan.price = CalculateComputedPlanPrice(this.$store, plan);
                if(!plan.monthlyPriceAltered && !plan.annualPriceAltered) {
                    plan.annualPrice = plan.price * 12
                }
                this.updatePlan(plan);
            })
        },
        addBenefitClick() {
            this.showModal = true;
        },
        closeAllModals() {
            this.showModal = false;
            this.showEditBenefit = false;
            this.showEditPlan = false;
        },
        ShowEditBenefit(benefit) {
            this.benefitToEdit = benefit;
            this.showEditBenefit = true;
        },
        ShowEditPlan() {
            this.showEditPlan = true;
        },
        UpdatePercentBreakage(value) {
            if((value === -1 && this.percentBreakage === 0) || (value === 1 && this.percentBreakage === 100)) {
                return
            }
            else {
                let tempBreakage = {"percent": this.percentBreakage + (value * 5), "type": this.planType}
                this.updatePercentBreakageStore(tempBreakage)
                this.updatePlanPrices();
            }
        },
        GoToOverview() {
            GoToComponent(this, 'overview');
        },
        toggleDMFeeChecked() {
            this.toggleIncludeDMFee();
            this.updatePlanPrices();
        },
        toggleProcessingFeeChecked() {
            this.toggleIncludeProcessingFee();
            this.updatePlanPrices();
        },
        updatePercentToSetTo(value) {
            this.percentToSetTo = value;
        },
        handleEscape(event) {
            if(event.key === 'Escape') {
                this.closeAllModals();
            }
        },
    },
    computed: {
        plans() {
            let plans = this.$store.getters.plansByType(this.planType);
            return plans;
        },
        /** One row per benefit per quantity (e.g. quantity 3 → 3 SliderRows for that benefit). */
        benefitRows() {
            const benefits = this.$store.getters.benefitsByType(this.planType);
            const rows = [];
            benefits.forEach((benefit) => {
            const rawQuantity = this.$store.getters.getBenefitQuantityForPlanType(benefit, this.planType) || 1;
            const quantity = canBenefitHaveMultipleQuantity(benefit) ? rawQuantity : 1;
            for (let q = 0; q < quantity; q++) {
                rows.push({
                benefit,
                key: `benefit-${benefit.id}-${this.planType}-${q}`,
                });
            }
            });
            return rows;
        },
        benefits() {
            let benefits = this.$store.getters.benefitsByType(this.planType);
            return benefits
        },
        percentBreakage() {
            return this.$store.state.percentBreakage[this.planType];
        },
        includeDMFee() {
            return this.$store.state.includeDMFee;
        },
        includeProcessingFee() {
            return this.$store.state.includeProcessingFee;
        },
        thisPlanType() {
            return this.$store.getters.getPlanTypeByIndex(this.planType)
        },
        planTypeString() {
            return this.$store.getters.getPlanTypeFromInt(this.planType);
        },
        percentDiscount() {
            let plan = this.plans[0];
            let planPrice = plan.annualPrice
            let sum = 0
            this.$store.state.benefits.forEach((benefit) => {
                const entry = benefit.planTypes.find(e => e.planTypeIndex === this.planType);
                if (entry) {
                    let benefitFrequency = benefit.frequencies[this.planType] === -1 ? plan.frequency : benefit.frequencies[this.planType]
                    const quantity = entry.quantity || 1;
                    sum += benefit.UCR * (12 / benefitFrequency) * quantity;
                }
            });
            let result = 100 - Math.ceil((planPrice / sum) * 100);
            //set plan discount here if these are adult plans
            if (this.planType === 0) {
                this.updateAdultPlanDiscount(result);
            }
            return result;
        }
    },
    mounted() {
        if(this.mode !== 'view') {
            this.updatePlanPrices();
        }
        this.localPlanType = this.planType
        this.localPlanTypeString = this.planTypeString;
        window.addEventListener('keydown', this.handleEscape);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleEscape);
    },
    watch: {
        benefits(newValue, oldValue) {
            if(newValue.length != oldValue.length) {
                this.updatePlanPrices();
            }
        },
        // Recalculate when benefit rows change (e.g. duplicate removed so row count drops)
        benefitRows(newRows, oldRows) {
            if (!oldRows || newRows.length !== oldRows.length) {
                this.updatePlanPrices();
            }
        },
        planType(newVal, oldVal) {
            this.updatePlanPrices();
            this.localPlanTypeString = this.planTypeString;
            this.showEditPlan = false;
        },
        localPlanTypeString(newVal) {
            this.setPlanTypeName({ id: this.planType, name: newVal });
        }
    }
  };
</script>

<style scoped>

#top-text-2 {
    margin: 0;
    margin-top: 1%;
    margin-bottom: 1%;
}

.input-as-text {
  background: none;
  border: 2px solid transparent;
  border-radius: 10px;
  outline: none;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  width: auto;
  text-align: center;
  font-size: 1.05em;
}

.input-as-text:hover {
    border: 2px solid var(--color-bright-blue)
}

#full-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0;
}

#window-2 {
    width: 85%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    border-radius: 20px;
}

#top-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

#top-row h2 {
    margin-left: 2em;
    margin-right: 2em;
    font-size: 1.3em;
}


h1 {
    margin: 0px;
    color: var(--font-color-teal)
}

.slider-rows {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
}

.btn-container {
    margin-top: 0.5em;
    display: flex;
    justify-content: space-around;
    width: 70%;
    margin-bottom: 0.5em;
    align-items: space-between;
}

.add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid var(--color-light-blue);
    border-radius: 40px;
    height: 4em;
    width: 40%;
    background-color: white;
    color: var(--color-bright-blue);
    font-size: 1.5em;
    font-weight: 600;
    padding-right: 0.7em;
    padding-left: 0.7em;
    cursor: pointer;
    max-height: 55px;
    margin-top: 0;
    margin-bottom: 0;
}

.btn-small {
    font-size: 1.15em;
    height: 2.5em;
    width: 30%;
}

.add-btn:active {
    border: 3px solid var(--color-bright-blue)
}

.add-btn:focus {
    outline: none;
}

.side-div {
    display: flex;
    align-items: center;
    justify-content: center;
}

.bottom-row {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
}

.fees-tab {
    flex: 1;
    border-right: 1px solid var(--color-medium-gray);
    padding-left: 3%;
    padding-right: 3%;
}

#fees-text {
    margin: 0;
    font-size: 1.5em;
    color: var(--color-dark-gray)
}


.line {
    width: 100%; /* If you still want the line to be full width */
    border-top: 1px solid var(--color-medium-gray);
    display: flex;
    margin: 0;
  }

.fees {
    display: flex;
    flex-direction: column;
}

.fee {
    margin-top: 0.4em;
    display: flex;
    justify-content: space-between;
    font-size: 1.2em;
}

.fee-price {
    font-weight: bold;
    padding-right: 0.5em;
}

.plans-tab {
    flex: 2.5;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-left: 1em;
    margin-right: 1em;
}

.plans {
    display: flex;
    width: 100%;
    justify-content: center;
}

.plan-description h3 {
    color: var(--color-dark-gray);
    display: flex;
    justify-content: center;
    margin: 1em;
    font-size: 1.3em;
}

</style>